import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import apiService from "../services/apiService";
import { Plus } from "lucide-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EditContent = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [content, setContent] = useState({
    description: "", title: "", duration: "", chapter_count: "", tags: "", rfid: "", img: "",
    is_kids_favourite: false, is_all_time_classic: false,
    //  is_sleep: false,
    content_type: "1",

  });
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  useEffect(() => { fetchContent(); }, []);

const sanitize = (value) => (value === "null" || value === null ? "" : value);

const fetchContent = async () => {
  try {
    const res = await apiService.fetchData(`admin/content/${id}`);
    if (!res.error && res.data) {
      setContent({
        title: sanitize(res.data.title),
        description: sanitize(res.data.description),
        duration: sanitize(res.data.duration),
        chapter_count: sanitize(res.data.chapter_count),
        tags: sanitize(res.data.tags),
        rfid: sanitize(res.data.rfid),
        img: sanitize(res.data.img),
        is_kids_favourite: res.data.is_kids_favourite === 1,
        is_all_time_classic: res.data.is_all_time_classic === 1,
        // is_sleep: res.data.is_sleep === 1,
        content_type: res.data.content_type?.toString() || "1"
      });
    }
  } catch (err) {
    console.error("Error fetching content:", err);
  }
};

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setContent({ ...content, [name]: type === "checkbox" ? checked : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    for (const key in content) {
      formData.append(key, content[key] === true ? "1" : content[key] === false ? "0" : content[key]);
    }
    try {
      const res = await apiService.putData(`admin/content/${id}`, formData);
      if (!res.error) navigate("/content");
    } catch (err) {
      console.error("Error updating content:", err);
    }
  };
  const deleteImage = async () => {
    try {
      const res = await apiService.deleteData(`admin/image/content/${id}`);
      if (!res.error) {
        toast.success("Image deleted!");
        fetchContent();
      } else {
        toast.error("Failed to delete image.");
      }
    } catch (err) {
      toast.error("Error deleting image.");
    }
  };
  
  const uploadImage = async () => {
    if (!selectedImage) return toast.error("Please select a file.");
    setIsUploading(true);
    const formData = new FormData();
    formData.append("id", id);
    formData.append("import_type", "content");
    formData.append("files", selectedImage);
    try {
      const res = await apiService.postData("admin/upload-image", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (!res.error) {
        toast.success("Image uploaded!");
        setShowModal(false);
        fetchContent();
      } else toast.error("File upload failed.");
    } catch (err) {
      toast.error("Upload failed");
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="row">
      <div className="col-12">
        <div className="card">
          <div className="card-header"><h4>Edit Content</h4></div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
            <div className="mb-3 form-group">
  <label>Content Preview</label>
  {content.img ? (
    <div style={{ position: "relative", display: "inline-block" }}>
      <img src={apiService.getFullImageUrl(content.img)} alt="Content" style={{ maxWidth: "200px", borderRadius: "8px" }} />
      <span
        style={{
          position: "absolute",
          top: "-8px",
          right: "-8px",
          backgroundColor: "#dc3545",
          color: "#fff",
          borderRadius: "50%",
          width: "24px",
          height: "24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer"
        }}
        onClick={deleteImage}
      >×</span>
    </div>
  ) : (
    <p>No image uploaded yet.</p>
  )}
  <div className="mt-2">
    <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setShowModal(true)}>
      {content.img ? "Update Image" : "Upload Image"}
    </button>
  </div>
</div>


              {["title", "description", "duration", "chapter_count", "tags", "rfid"].map((field, i) => (
                <div className="form-group" key={i}>
                  <label>{field.replace("_", " ").replace(/\b\w/g, l => l.toUpperCase())}</label>
                  {field === "description" ? (
                    <textarea name={field} className="form-control" value={content[field]} onChange={handleChange} />
                  ) : (
                    <input type={field === "chapter_count" ? "number" : "text"} name={field} className="form-control" value={content[field]} onChange={handleChange} />
                  )}
                </div>
              ))}

              {["is_kids_favourite", "is_all_time_classic"].map((key, i) => (
                <div className="form-group" key={i}>
                  <label>
                    <input type="checkbox" name={key} checked={content[key]} onChange={handleChange} />{" "}
                    {key.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase())}
                  </label>
                </div>
              ))}
 <div className="form-group mt-3">
                <label>Content Type</label>
                <div>
                  {["1", "2", "3"].map((val) => (
                    <label key={val} className="me-3">
                      <input
                        type="radio"
                        name="content_type"
                        value={val}
                        checked={content.content_type === val}
                        onChange={handleChange}
                      />{" "}
                      {val === "1" ? "Story" : val === "2" ? "Learning" : "Song"}
                    </label>
                  ))}
                </div>
              </div>
              <div className="d-flex gap-2 mt-3">
                <button type="submit" className="btn btn-primary"><Plus size={16} /> Update Content</button>
                <button type="button" className="btn btn-secondary" onClick={() => navigate("/content")}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {showModal && (
        <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Upload New Image</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                <input type="file" accept="image/*" onChange={(e) => {
                  const file = e.target.files[0];
                  setSelectedImage(file);
                  if (file) setPreviewImage(URL.createObjectURL(file));
                }} className="form-control" />
                {previewImage && <img src={previewImage} alt="Preview" className="mt-3" style={{ maxWidth: "100%", borderRadius: "8px" }} />}
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary" onClick={uploadImage} disabled={isUploading}>
                  {isUploading ? "Uploading..." : "Save"}
                </button>
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditContent;
